export default {
    ThemeGreen: '#44DD9D',
    ThemeBlue: '#449DDD',

    TextBlack: '#3A3A3A',
    TextGray: '#616161',

    Background: '#E0E0E0',

    White: '#FFFFFF',
    Yellow: '#F2C94C',
    Red: '#EB5757',
    Orange: '#F2994A',
    Gray3: '#828282',
    Gray5: '#E0E0E0',

    H1: '24px',
    H2: '18px',
    H3: '14px',
    H4: '12px',

    P1: '14px',
    P2: '12px',
    P3: '10px'
}